import styled from 'styled-components';

export const MovieBlock = styled.article`
  width: 200px;

  border: 1px solid transparent;
  margin: 1rem;

  &:first-child {
    margin-left: 0;
  }

  .img-wrapper {
    line-height: 0;
    border-radius: 1rem;
    overflow: hidden;
    /* max-height: 360px; */
    position: relative;
    margin-bottom: 0.5rem;
    box-shadow: 0 1rem 1.5rem -1rem rgba(16, 30, 38, 0.5);
    cursor: pointer;
    margin-bottom: 1rem;

    transition: all 0.3s ease;
    /* margin: 0 1rem; */
    &:hover {
      transform: scale(1.03);
    }

    &:hover .movieOverview {
      transform: translateY(0%);
    }
    transition: all 0.3s ease;
    &:hover {
      box-shadow: 0 1rem 3.5rem -1rem rgba(16, 30, 38, 0.5);
    }

    .movieOverview {
      background-color: rgba(0, 0, 0, 0.8);
      color: var(--white);
      padding: 1rem;
      font-size: 0.8rem;
      position: absolute;
      z-index: 20;
      bottom: 0;
      left: 0;
      display: none;

      transform: translateY(100%);
      transition: all 0.4s ease;

      @media screen and (min-width: 480px) {
        display: block;
      }

      P {
        margin: 0;
        font-weight: normal;
        letter-spacing: 0;
      }
    }
  }

  img.movieThumbnail {
    width: 100%;
    /* border-radius: 1rem; */
  }

  .details {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0.75rem;

    .btns {
      display: flex;
      margin-left: 0.5rem;
    }
  }
`;
